const permissionsNames = {
  home: 'Home',
  listings: 'Listings',
  listingsAddNew: 'Listings Add New',
  listingsLibrary: 'Listings Library',
  productManageStock: 'Manage Stock of Product',
  profilePayment: 'Profile Payment',
  promotions: 'Promotions',
  automaticPromotions: 'Automatic Promotions',
  settingsCouponManager: 'Coupon Manager',
  promotionsBrowse: 'Promotions Browse',
  promotionsRequestCustom: 'Promotions Request Complex',
  promotionsRequestSimple: 'Promotions Request Basic',
  quoteDemo: 'Quote Demo',
  quoteTreatmentPlan: 'Quote Treatment Plan',
  quotingRedesign: 'Quoting Redesign',
  sales: 'Sales',
  fraudOrders: 'On Hold Orders',
  bannerManager: 'Banner Manager',
  homepageBanner: 'Homepage Banner',
  membershipSkuRequest: 'Membership',
  directFulfillment: 'Direct Fulfillment',
  directFulfillmentRequestButton: 'Direct Fulfillment Request',
  directFulfillmentAddButton: 'Direct Fulfillment Add',
  affiliate: 'Affiliates',
  orders: 'Orders',
  ordersMDI: 'Orders MDI Hairdefence',
  ordersDrDauer: 'Orders Dr. Dauer Hairdefence',
  deposits: 'Deposits',
  subscriptions: 'Subscriptions',
  reporting: 'Reporting',
  customers: 'Customers',
  customersImport: 'Import Customers',
  customersList: 'All Customers',
  customersRequestAccess: 'Request Access List',
  marketing: 'Marketing',
  help: 'Help',
  auditLogs: 'Audit Logs',
  profile: 'Profile',
  settings: 'Settings',
  settingsCompare: 'Settings Compare',
  settingsGeneral: 'Settings Store Logos',
  settingsHomepage: 'Settings Homepage',
  settingsNotifications: 'Settings Notifications',
  settingsPickupLocations: 'Settings Pickup Locations',
  settingsRecaptcha: 'Settings Recaptcha',
  settingsReview: 'Settings Review',
  settingsRewards: 'Settings Rewards',
  settingsShipping: 'Settings Shipping',
  settingsSocialMedia: 'Settings Social Media',
  settingsTagline: 'Settings Tagline',
  settingsWhishlist: 'Settings Wishlist',
  settingsSummary: 'Settings Summary',
  settingsSurveyQuestions: 'Settings Survey Questions',
  settingsColorPalette: 'Settings Color Palette',
  settingsUserPlans: 'Settings Plans',
  settingsPaymentMethods: 'Settings Payment Methods',
  settingsRequestOneLoginAccess: 'Settings Request Access',
  settingsTaxRates: 'Settings Tax Rates',
  settingsReferralProgram: 'Settings Referral Program',
  bulkPriceUpdate: 'Bulk Price Update',
  massEditActive: 'Bulk Edit Active',
  massEditDraft: 'Bulk Edit Draft',
  massEditSaveAll: 'Bulk Edit Save All',
  massEditDeleteAll: 'Bulk Edit Remove All',
  settingsHomepagePromoTabs: 'Homepage Promo Tabs',
  settingsHomepagePromoCarousels: 'Homepage Promo Carousels',
  settingsHomepageWelcomeBlock: 'Homepage Welcome Block',
  settingsHomepageCTABlock: 'Homepage CTA Block',
  settingsHomepageRewardBlock: 'Homepage Reward Block',
  settingsHomepageTestimonials: 'Homepage Testimonials',
  settingsHomepageInstagramBlock: 'Homepage Instagram Block',
  settingsAppointmentFormBlock: 'Homepage Appointment Form Block',
  settingsAboutUsPage: 'About Us Page',
  settingsBeforeAfterGallery: 'Before/After Gallery Page',
  settingsStripe: 'Stripe Configs',
  settingsDNS: 'DNS Configs',
  adminPanel: 'Admin Panel',
  adminUserStoresTab: 'Admin User Stores Tab',
  adminUserStoresCreate: 'Admin User Stores Create',
  adminUserStoresAssign: 'Admin User Stores Assign',
  adminUserStoresRemove: 'Admin User Stores Remove',
  adminUserStoresEdit: 'Admin User Stores Edit',
  adminStoresTab: 'Admin Stores Tab',
  adminStoresAdd: 'Admin Stores Add',
  adminStoresEdit: 'Admin Stores Edit',
  adminStoresRemove: 'Admin Stores Remove',
  adminFeatureFlipperTab: 'FeatureFlipper Tab',
  adminFeatureFlipperAddConfig: 'FeatureFlipper Add Config',
  adminFeatureFlipperEditConfig: 'FeatureFlipper Edit Config',
  adminFeatureFlipperRemoveConfig: 'FeatureFlipper Remove Config',
  adminFeatureFlipperChangeUserConfig: 'FeatureFlipper Change User Config',
  adminSubscriptionTierTab: 'SubscriptionTier Tab',
  adminSubscriptionTierAdd: 'SubscriptionTier Add',
  adminSubscriptionTierEdit: 'SubscriptionTier Edit',
  adminSubscriptionTierRemove: 'SubscriptionTier Remove',
  adminBannerSlidesTab: 'BannerSlides Tab',
  adminBannerSlidesAdd: 'BannerSlides Add',
  adminBannerSlidesEdit: 'BannerSlides Edit',
  adminBannerSlidesRemove: 'BannerSlides Remove',
  adminHelpConfigurations: 'Admin Help Configurations',
  adminHelpCategoryTab: 'Admin Help Category Tab',
  adminHelpCategoryAdd: 'Admin Help Category Add',
  adminHelpCategoryRemove: 'Admin Help Category Remove',
  adminHelpCategoryEdit: 'Admin Help Category Edit',
  adminHelpSubCategoryTab: 'Admin Help Sub Category Tab',
  adminHelpSubCategoryAdd: 'Admin Help Sub Category Add',
  adminHelpSubCategoryRemove: 'Admin Help Sub Category Remove',
  adminHelpSubCategoryEdit: 'Admin Help Sub Category Edit',
  adminHelpTopicTab: 'Admin Help Topic Tab',
  adminHelpTopicAdd: 'Admin Help Topic Add',
  adminHelpTopicRemove: 'Admin Help Topic Remove',
  adminHelpTopicEdit: 'Admin Help Topic Edit',
  adminSMReport: 'Admin SM Report',
  analytics: 'Analytics',
  dataMapping: 'Data Mapping',
  syncEventLogs: 'Sync Event Logs',
  ordersSurveyQuestion: 'Orders Survey Question',
  giftCards: 'Gift Cards',
  giftCardsCreate: 'Gift Cards Create',
  giftCardsEdit: 'Gift Cards Edit',
  giftCardsRemove: 'Gift Cards Remove',
  promotionsLibrary: 'Promotions Library',
  quotePatient: 'Quote Patient',
  quoteGroups: 'Quote Groups',
  quoteListings: 'Quote Listings',
  quoteSummary: 'Quote Summary',
  quotesForAllPeriods: 'DermPRO Quote',
  quotingV2: 'Quoting V2',
  automatedQuotes: 'Automated Quotes',
  adminSMBannerTab: 'Admin SMBanner Tab',
  quoteMarketingSegments: 'Quote Marketing Segments',
};

export default permissionsNames;
